import { TypedDocumentNode, gql } from '@apollo/client';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { useQuery } from '@sorare/core/src/hooks/graphql/useQuery';

import { UnsealingAnimation } from '.';
import type {
  UnsealingAnimationQuery,
  UnsealingAnimationQueryVariables,
} from './__generated__/index.withFetch.graphql';

const query = gql`
  query UnsealingAnimationQuery($slugs: [String!]!) {
    anyCards(slugs: $slugs) {
      slug
      ...UnsealingAnimation_anyCard
    }
  }
  ${UnsealingAnimation.fragments.anyCard}
` as TypedDocumentNode<
  UnsealingAnimationQuery,
  UnsealingAnimationQueryVariables
>;

type Props = {
  rarity: Rarity;
  selectedCardsSlugs: string[];
  onClose: () => void;
};
export const UnsealingAnimationWithFetch = ({
  rarity,
  selectedCardsSlugs,
  onClose,
}: Props) => {
  const { data } = useQuery(query, {
    variables: {
      slugs: selectedCardsSlugs,
    },
    skip: selectedCardsSlugs.length === 0,
  });

  const cards = data?.anyCards || [];

  return <UnsealingAnimation rarity={rarity} cards={cards} onClose={onClose} />;
};
